export function changeFileExtension(imageUrl, format, size) {
    if (!imageUrl) return null;
    const pieces = imageUrl.split('.');
    pieces.pop();
    if (size) {
        const lastPieceIndex = pieces.length - 1;
        pieces[lastPieceIndex] = pieces[lastPieceIndex].replace(/(.*s-l)(\d+)/, `$1${size}`);
    }
    pieces.push(format);
    return pieces.join('.');
}
